import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=0671d7a4&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"
import style0 from "./TheList.vue?vue&type=style&index=0&id=0671d7a4&prod&scoped=true&lang=css"
import style1 from "./TheList.vue?vue&type=style&index=1&id=0671d7a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671d7a4",
  null
  
)

export default component.exports